import { render } from '@wordpress/element';
import App from './App';
import './style.css';

const rootElement = document.getElementById('uavc-settings-app');

if (rootElement) {
  render(<App />, rootElement);
}
